import {
  SITE_INSPECTION_GATE,
  LOCATION_APPROVAL_PENDING,
  POC_LIST_BY_SITEID,
  CHECK_LOCATION,
  SITE_INSPECTION_GATE_SOLUTION,
  GATE_DETAIL,
  SITE_INSPECTION_CHECKLIST,
  SITE_CARNIVAL_CHECKLIST,
  SITE_CARNIVAL_CHECKLIST_FILLED,
  SITE_CONSUMABLE_ITEMS
} from "./type";

const initalState = {
  siteData: {},
  siteDataSolution: {},
  locationApproval: {},
  pocListBySiteId: [],
  locationCheck: {},
  gateDetail: {},
  siteInspectionChecklist: {},
  siteCarnivalChecklist: {},
  siteCarnivalChecklistFilled: {},
  siteConsumables: {}
};

const siteInspectionReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SITE_INSPECTION_GATE:
      return {
        ...state,
        siteData: payload,
        gateDetail: {},
      };
    case SITE_INSPECTION_GATE_SOLUTION:
      return {
        ...state,
        siteDataSolution: payload,
        gateDetail:{},
      };
    case GATE_DETAIL:
      return {
        ...state,
        gateDetail: payload,
      };
    case LOCATION_APPROVAL_PENDING:
      return {
        ...state,
        locationApproval: payload,
      };
    case POC_LIST_BY_SITEID:
      return {
        ...state,
        pocListBySiteId: payload,
      };
    case CHECK_LOCATION:
      return {
        ...state,
        locationCheck: payload,
      };
    case SITE_INSPECTION_CHECKLIST:
      return {
        ...state,
        siteInspectionChecklist: payload
      };
    case SITE_CARNIVAL_CHECKLIST:
      return {
        ...state,
        siteCarnivalChecklist: payload
      };  
    case SITE_CARNIVAL_CHECKLIST_FILLED:
      return {
        ...state,
        siteCarnivalChecklistFilled: payload
      };
    case SITE_CONSUMABLE_ITEMS:
      return {
        ...state,
        siteConsumables: payload
      };  
    default:
      return {
        ...state,
      };
  }
};

export default siteInspectionReducer;
